// src/components/crm/ApplicantTable.js
import React from 'react';
import { ArrowUp, ArrowDown, Edit, Trash2, Mail, Briefcase } from 'lucide-react';

const ApplicantTable = ({ applicants, openModal, requestSort, sortConfig, onDelete }) => {
    
    // Helper for sorting icons
    const getSortIndicator = (key) => {
        if (sortConfig.key !== key) return <span className="inline-block w-4"></span>;
        return sortConfig.direction === 'ascending' ?
            <ArrowUp className="inline-block ml-1 h-4 w-4 text-gray-600" /> :
            <ArrowDown className="inline-block ml-1 h-4 w-4 text-gray-600" />;
    };

    // Helper for status colors (Matches your Kanban Board)
    const getStatusColor = (status) => {
        const colors = {
            'Applied': 'bg-blue-100 text-blue-800',
            'Interviewing': 'bg-yellow-100 text-yellow-800',
            'Offer Sent': 'bg-purple-100 text-purple-800',
            'Hired': 'bg-green-100 text-green-800',
            'Rejected': 'bg-gray-100 text-gray-800'
        };
        return colors[status] || 'bg-gray-100 text-gray-800';
    };

    return (
        <div className="mt-6 bg-white shadow-sm rounded-lg overflow-x-auto">
            <table className="w-full text-sm text-left text-gray-500">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                    <tr>
                        <th className="px-6 py-3 cursor-pointer hover:bg-gray-100" onClick={() => requestSort('name')}>
                            <div className="flex items-center">Name {getSortIndicator('name')}</div>
                        </th>
                        <th className="px-6 py-3 cursor-pointer hover:bg-gray-100" onClick={() => requestSort('role')}>
                            <div className="flex items-center">Role {getSortIndicator('role')}</div>
                        </th>
                        <th className="px-6 py-3 cursor-pointer hover:bg-gray-100" onClick={() => requestSort('email')}>
                            <div className="flex items-center">Email {getSortIndicator('email')}</div>
                        </th>
                        <th className="px-6 py-3 cursor-pointer hover:bg-gray-100" onClick={() => requestSort('createdAt')}>
                            <div className="flex items-center">Date Applied {getSortIndicator('createdAt')}</div>
                        </th>
                        <th className="px-6 py-3 cursor-pointer hover:bg-gray-100" onClick={() => requestSort('status')}>
                            <div className="flex items-center">Status {getSortIndicator('status')}</div>
                        </th>
                        <th className="px-6 py-3 text-right">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {applicants.map(applicant => (
                        <tr key={applicant.id} className="bg-white border-b hover:bg-gray-50 cursor-pointer" onClick={() => openModal(applicant)}>
                            <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">{applicant.name}</td>
                            <td className="px-6 py-4">
                                <div className="flex items-center gap-2">
                                    <Briefcase size={14} className="text-gray-400"/>
                                    {applicant.role || '-'}
                                </div>
                            </td>
                            <td className="px-6 py-4">
                                <div className="flex items-center gap-2">
                                    <Mail size={14} className="text-gray-400"/>
                                    {applicant.email || '-'}
                                </div>
                            </td>
                            <td className="px-6 py-4">
                                {/* Safe date check in case createdAt is missing */}
                                {applicant.createdAt?.toDate ? applicant.createdAt.toDate().toLocaleDateString() : 'N/A'}
                            </td>
                            <td className="px-6 py-4">
                                <span className={`px-2 py-1 rounded-full text-xs font-semibold ${getStatusColor(applicant.status)}`}>
                                    {applicant.status}
                                </span>
                            </td>
                            <td className="px-6 py-4 text-right">
                                <div className="flex justify-end items-center space-x-2" onClick={(e) => e.stopPropagation()}>
                                    <button onClick={() => openModal(applicant)} className="p-2 rounded-md hover:bg-gray-200 text-gray-600">
                                        <Edit size={16}/>
                                    </button>
                                    <button 
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onDelete(applicant);
                                        }} 
                                        className="p-2 rounded-md hover:bg-red-100 text-red-600"
                                    >
                                        <Trash2 size={16}/>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))}
                    {applicants.length === 0 && (
                        <tr>
                            <td colSpan="6" className="text-center py-10 text-gray-500">No applicants found.</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default ApplicantTable;